export default __webpack_public_path__ + "static/media/CybersecurityMaturityAssessment.50ee0bdf.svg";